import { useCallback, useMemo } from "react";

import { useApi } from "shared/services/api/useApi";

export const useTimeOff = () => {
    const { getDataAsync } = useApi();

    const getTimeOff = useCallback(async (params) => {
        const payload = await getDataAsync("timeOff", { params: params });
        return payload.json();
    }, [getDataAsync]);

    return useMemo(() => {
        return { getTimeOff };
    }, [getTimeOff]);
};
